var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[(_vm.resufreshed)?_c('router-view'):_vm._e()],1),_c('Alert'),_vm._l((_vm.dialogs),function(dialog){return _c(dialog.render,{key:dialog.key,tag:"component"})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }